var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
const API_BASE_URL = window._env_.REACT_APP_SIGNO_API_URL;
export class ServiceFormFillingRepository {
    checkIsDpdMandatory(serviceFormFillingId) {
        return __awaiter(this, void 0, void 0, function* () {
            var response = yield axios.get(`${API_BASE_URL}/ServiceFormFilling/${serviceFormFillingId}/isDpdMandatory`);
            return response.data;
        });
    }
    updateFormResponses(responses, serviceFormFillingId, version) {
        return __awaiter(this, void 0, void 0, function* () {
            var response = yield axios.put(`${API_BASE_URL}/ServiceFormFilling/${serviceFormFillingId}`, { responses: responses }, { params: { version } });
            return response.data;
        });
    }
    createNewForm(companyId, serviceId, version) {
        return __awaiter(this, void 0, void 0, function* () {
            var versionPath = version ? `&version=${version}` : '';
            var response = yield axios.post(`${API_BASE_URL}/ServiceFormFilling/create?companyId=${companyId}&serviceId=${serviceId}${versionPath}`);
            return response.data;
        });
    }
    getServiceFormFilling(companyId, serviceId) {
        return __awaiter(this, void 0, void 0, function* () {
            var response = yield axios.get(`${API_BASE_URL}/ServiceFormFilling?companyId=${companyId}&serviceId=${serviceId}`);
            return response.data;
        });
    }
    getFormJson(serviceId) {
        return __awaiter(this, void 0, void 0, function* () {
            var response = yield axios.get(`${API_BASE_URL}/ServiceFormConfig/${serviceId}/form`);
            return response.data;
        });
    }
    getFormSummary(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            var response = yield axios.get(`${API_BASE_URL}/Company/${companyId}/form-response-summary`);
            return response.data;
        });
    }
    checkIsEipdRequired(serviceFormFillingId) {
        return __awaiter(this, void 0, void 0, function* () {
            var response = yield axios.get(`${API_BASE_URL}/ServiceFormFilling/${serviceFormFillingId}/eipd`);
            return response.data;
        });
    }
    calculateEipd(serviceFormFillingId) {
        return __awaiter(this, void 0, void 0, function* () {
            var response = yield axios.post(`${API_BASE_URL}/ServiceFormFilling/${serviceFormFillingId}/eipd`);
            return response.data;
        });
    }
    completeServiceFormFilling(serviceFormFillingId) {
        return __awaiter(this, void 0, void 0, function* () {
            var response = yield axios.post(`${API_BASE_URL}/ServiceFormFilling/${serviceFormFillingId}/completed`);
            return response.data;
        });
    }
}
